import { create } from "zustand";
import { ResponseState } from "./types";

/**
 * Response store for managing form response state
 * This store is not persisted as it's temporary state
 */
const useResponseStore = create<ResponseState>()((set) => ({
  step: "intro",
  setStep: (step) => set({ step }),
  responses: [],
  setResponses: (responses) => set({ responses }),
  currentIndex: 0,
  setCurrentIndex: (index) => set({ currentIndex: index }),
  fixingIndex: null,
  setFixingIndex: (index) => set({ fixingIndex: index }),
}));

export default useResponseStore;
